/******************************************************************************
 * CacheManager2 Class
 * version: 1.0.1, release: 07.09.2018
 * author: albert lang, albert@jumptomorrow.com
 * ----------------------------------------------------------------------------
 * description:
 * 
 * dependencies: none
 * 
 * todos:
 * 
******************************************************************************/

import * as localForage from "localforage";

const cache = localForage.createInstance({
	name: 'datascan-media-cache'
});


//============================================================================= CacheManager2 Class
export class CacheManager2 {

	static async get(url){
		let uri = url.split('?')[0];

		let item = await cache.getItem(uri);

		if (item) return item;	//already cached

		return url;
	}


	static async set(url, override=false){
		let src = await cache.getItem(url)
		if (src) return

		let img = new Image();
		img.crossOrigin = 'anonymous';
		img.onload = e => {
			let cvs = document.createElement('canvas');
			let ctx = cvs.getContext('2d');
			cvs.width = img.width;
			cvs.height = img.height;
			ctx.drawImage(img, 0, 0);
			let data = cvs.toDataURL();
			// console.log('complete!', cvs.width, cvs.height, e);

			cache.setItem(url, data)
		}
		img.src = url;
	}
}
